import { create } from 'zustand';
import type { LoginResponse } from '@shared/api';

interface TokenType {
  token: string | null;
  userData: LoginResponse | null;
  setToken: (token: string | null) => void;
  clear: () => void;
}

export const useTokenStore = create<TokenType>((set) => ({
  userData: null,
  token: null,

  setToken: (token) => {
    set((state) => ({ token, userData: state.userData ? { ...state.userData, token: token ?? '' } : null }));
  },

  clear: () => set({ token: null, userData: null }),
}));
